// extracted by mini-css-extract-plugin
export var section = "_33-1";
export var topNav = "_33-0";